/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AppearanceStyle = {
    Modern: 'Modern',
    Classic: 'Classic'
} as const;
export type AppearanceStyle = typeof AppearanceStyle[keyof typeof AppearanceStyle];


export function instanceOfAppearanceStyle(value: any): boolean {
    for (const key in AppearanceStyle) {
        if (Object.prototype.hasOwnProperty.call(AppearanceStyle, key)) {
            if (AppearanceStyle[key as keyof typeof AppearanceStyle] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AppearanceStyleFromJSON(json: any): AppearanceStyle {
    return AppearanceStyleFromJSONTyped(json, false);
}

export function AppearanceStyleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppearanceStyle {
    return json as AppearanceStyle;
}

export function AppearanceStyleToJSON(value?: AppearanceStyle | null): any {
    return value as any;
}

export function AppearanceStyleToJSONTyped(value: any, ignoreDiscriminator: boolean): AppearanceStyle {
    return value as AppearanceStyle;
}

